import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';

export const fetchRemoteCalendars = createAsyncThunk(
    'remoteCalendar/fetchAll',
    async ({ page, query }, { getState, rejectWithValue }) => {
        try {
            const perPage = getState().general.settings.perPage;
            const { maxPageNumber, data } = await API.remoteCalendar.get(page, perPage, query);
            const prevList = getState().remoteCalendar.list;

            return {
                maxPageNumber,
                list: page ? [...prevList, ...data] : data,
            };
        } catch (e) {
            notification.error({ message: 'Error', description: e.message || 'Server error' });
            return rejectWithValue(e.message);
        }
    },
);

export const createRemoteCalendar = createAsyncThunk(
    'remoteCalendar/create',
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            const calendar = await API.remoteCalendar.create(data);
            notification.info({ message: 'Success', description: 'Calendar was created' });

            dispatch({
                type: 'general/toggleModal',
                payload: { modal: 'remoteCalendar', isOpen: false },
            });

            return calendar;
        } catch (e) {
            notification.error({ message: 'Error', description: e.message || 'Server error' });
            return rejectWithValue(e.message);
        }
    },
);

export const updateRemoteCalendar = createAsyncThunk(
    'remoteCalendar/update',
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            const calendar = await API.remoteCalendar.update(id, data);
            notification.info({ message: 'Success', description: 'Calendar was updated' });

            dispatch({
                type: 'general/toggleModal',
                payload: { modal: 'remoteCalendarEdit', isOpen: false },
            });

            return calendar;
        } catch (e) {
            notification.error({ message: 'Error', description: e.message || 'Server error' });
            return rejectWithValue(e.message);
        }
    },
);

export const deleteRemoteCalendar = createAsyncThunk('remoteCalendar/delete', async ({ id }, { rejectWithValue }) => {
    try {
        await API.remoteCalendar.delete(id);
        notification.info({ message: 'Success', description: 'Calendar was deleted' });
        return id;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});
